/* SteinKunstWerk Custom Layer 1.1.1 */
window.SKWCustomLayer=window.SKWCustomLayer||{version:'1.1.1',themeLayer:'skw-custom-layer',initialized:false};
(function(){
  function cleanInvalidRatings(root){
    (root||document).querySelectorAll('[class*="rating"],[class*="review"],[data-rating],[aria-label]').forEach(function(el){
      var text=(el.textContent||'').trim().toLowerCase();
      var aria=(el.getAttribute('aria-label')||'').trim().toLowerCase();
      if(text==='nan'||text==='nan/5'||aria.indexOf('nan')!==-1){
        el.hidden=true;
        el.setAttribute('aria-hidden','true');
      }
    });
  }
  document.addEventListener('DOMContentLoaded',function(){
    window.SKWCustomLayer.initialized=true;
    document.documentElement.classList.add('skw-custom-layer-ready');
    cleanInvalidRatings(document);
  });
})();